import React from "react";
import { Box, CircularProgress } from "@mui/material";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormBlogSection from "../../components/blog-section/FormBlogSection";
import { useGetBlogSection } from "../../hooks/blog-section/useGetBlogSection";
import { useUpdateBlogSection } from "../../hooks/blog-section/useUpdateBlogSection";

const BlogSectionPage = () => {
    const { isLoading, error, sectionData } = useGetBlogSection();
    const { updateBlogSectionMutate, isPending } = useUpdateBlogSection();

    if (isLoading) {
        return (
            <WrapperSection>
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    if (error) return null;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormBlogSection
                currentData={sectionData}
                onSubmit={updateBlogSectionMutate}
                isLoading={isPending}
            />
        </WrapperSection>
    );
};

export default BlogSectionPage;
